import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriversService } from '../root/drivers.service';

@Pipe({
  name: 'triangle',
})
export class TrianglePipe implements PipeTransform {
  constructor(private driverService: DriversService) {}

  // tslint:disable-next-line
  transform(
    drivers: {
      phone: string;
      secondsWaiting: number;
    }[],
  ): Observable<number> {
    return this.driverService.activeDriverList$.pipe(
      map((activeDrivers) => {
        const driverz = (activeDrivers || []).filter(
          (value) => !!(drivers || []).find((value1) => value1.phone === value.phoneNumber),
        );
        return driverz.filter((driver) => !!driver.actionNeeded).length;
      }),
    );
  }
}
